// 若沒有設定環境變數，自動根據目前訪問的網域組出 API / WebSocket 網址
const getDefaultServerUrl = () => {
  return `${window.location.protocol}//${window.location.host}`;
};

const getDefaultWsUrl = () => {
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${protocol}//${window.location.host}`;
};

const config = {
    server: process.env.REACT_APP_SERVER_URL || getDefaultServerUrl(),
    ws_server: process.env.REACT_APP_WS_URL || getDefaultWsUrl(),
};

export default config;